module.exports = ".thumbService\r\n{\r\n\tbackground-size: 42%!important;\r\n\tbackground-repeat: no-repeat!important;\r\n\tbackground-position: center!important;\r\n}\r\n\r\n.padding-xs-dv-msi .img-responsive{\r\n  width: 100%;\r\n}\r\n\r\n.top-banner{\r\n  background-size: cover!important;\r\n  background-position: center!important;\r\n  width: 100%;\r\n  height: 270px;\r\n  text-align: center;\r\n  display: table;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services/services.component.css
// module id = ./src/app/components/services/services.component.css
// module chunks = main